export default {
  // id: 2,
  gameColor: '#911717',
  futureBet: false,
  systemBet: false,
  additionalBetslipConfig: true,
  betslipConfiguration: {},
  adapters: [
    {
      name: 'GcmAdapter',
      type: 'Product',
      channels: [],
    },
  ],
  bettingType: 'races',
  ticketType: 'ngsTicket',
  bettingPreview: 'BettingPreviewRaces',
  bettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value or overriden in games static
      label: '',
      clientId: 1,
      betId: 0, // from config/bets ID
      betType: 'normal', // standard, bet type
      betDisplayName: 'winner', // displayName, from config/bets name
      shortcut: '+',
      inputType: 'text',
      inputFields: 6, // depends on the number contestants, from config/numberOfContestants
      betName: 'winner',
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 6,
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 2,
      betId: 1, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'show', // displayName, from config/bets name
      shortcut: 'i',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'show',
      additionalInputs: [],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
        {
          outcome: 6,
          shortcut: '6',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 3,
      betId: 2, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'place', // displayName, from config/bets name
      shortcut: 't',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'place',
      additionalInputs: [],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
        {
          outcome: 6,
          shortcut: '6',
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 4,
      betId: 3, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'sum_first_three', // displayName, from config/bets name
      limit: 10.5,
      outcomes: ['under', 'over'],
      shortcut: 'w',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'sum3',
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 5,
      betId: 4, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'sum_first_two', // displayName, from config/bets name
      limit: 7.5,
      outcomes: ['under', 'over'],
      shortcut: 'e',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'sum2',
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 6,
      betId: 5, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'not_winner', // displayName, from config/bets name
      shortcut: 'o',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'notWinner',
      additionalInputs: [],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
        {
          outcome: 6,
          shortcut: '6',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 7,
      betId: 6, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'not_place', // 'Not In Two' displayName, from config/bets name
      shortcut: 'g',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'out2',
      additionalInputs: [],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
        {
          outcome: 6,
          shortcut: '6',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 8,
      betId: 7, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'not_show', // 'Not In Three' displayName, from config/bets name
      shortcut: 'h',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'out3',
      additionalInputs: [],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
        {
          outcome: 6,
          shortcut: '6',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
        {
          type: 'validOdd',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 9,
      betId: 8, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'winner_even_odd', // displayName, from config/bets name
      outcomes: ['even', 'odd'],
      shortcut: 'p',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'evenOdd',
      additionalInputs: [],
      outcomeShortcuts: [
        // Shortcuts that have special action if pressed on this bet
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 10,
      betId: 9, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'winner_under_over', // displayName, from config/bets name
      outcomes: ['under', 'over'],
      shortcut: 'r',
      inputType: 'text',
      inputFields: 1, // (id > 0 && id < 10)
      betName: 'higherLower',
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 11,
      betId: 10, // from config/bets ID
      betType: 'normal', // standard, bet type
      betDisplayName: 'forecast', // displayName, from config/bets name
      shortcut: 'f',
      inputType: 'text',
      inputFields: 12, // depends on the number contestants,  (number contestant * 2)
      betName: 'forecast',
      inputRows: 2,
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'validForecast',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 12,
      betId: 11, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'tricast', // displayName, from config/bets name
      shortcut: 'j',
      inputType: 'text',
      inputFields: 18, // depends on the number contestants,  (number contestant * 2)
      betName: 'tricast',
      inputRows: 3,
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'validTricast',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 13,
      betId: 12, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'reverse_forecast', // displayName, from config/bets name
      shortcut: 's',
      inputType: 'text',
      inputFields: 6, // depends on the number contestants,  (number contestant * 2)
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 6,
          min: 2,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      clientId: 14,
      betId: 13, // from config/bets ID
      betType: 'special', // standard, bet type
      betDisplayName: 'reverse_tricast', // displayName, from config/bets name
      shortcut: 'k',
      inputType: 'text',
      inputFields: 6, // depends on the number contestants,  (number contestant * 2)
      additionalInputs: [],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 6, // depends on the number contestants, from config/numberOfContestants
        },
        {
          type: 'pattern',
          expression: /^[1-6]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 6,
          min: 3,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: false, // from config/bets value or overriden in games static
      label: '',
      clientId: 15,
      betId: 0, // from config/bets ID
      betType: 'custom', // standard, bet type
      betDisplayName: 'winner', // displayName, from config/bets name
      shortcut: '+ ',
      inputType: 'text',
      inputFields: 1, // depends on the number contestants, from config/numberOfContestants
      betName: 'winner',
      additionalInputs: ['system'],
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'pattern',
          expression: /^(?!.*(.).*\1)[1-6]{1,6}$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 6,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
  ],
  additionalBettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value or overriden in games static
      label: 'system',
      clientId: 'system',
      betId: 0, // from config/bets ID
      betType: 'system', // standard, bet type
      betDisplayName: 'system', // displayName, from config/bets name
      shortcut: 's',
      inputType: 'text',
      inputFields: 1, // depends on the number contestants, from config/numberOfContestants
      betName: 'system',
      outcomeShortcuts: [
        {
          outcome: null,
          shortcut: 'd',
          action: {
            name: 'auto_fill',
          },
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'pattern',
          expression: /^(?!.*(.).*\1)[1-6]{1,6}$/, // only numbers, depends on the number contestants
        },
      ],
      betValidations: [
        {
          type: 'validForecast',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
  ],
  shortcuts: {
    '+': {
      id: 1,
      action: 'ticket',
      active: true,
      name: 'winner',
      shortcut: '+',
      order: 1,
    },
    '+ ': {
      id: 15,
      action: 'ticket',
      active: false,
      name: 'winner',
      shortcut: '+ ',
      order: 2,
    },
    '/': {
      action: 'resetTicket',
      active: true,
      name: 'reset_ticket',
      shortcut: '/',
      order: 3,
    },
    q: {
      action: 'results',
      active: true,
      name: 'results',
      shortcut: 'q',
      order: 4,
    },
    's ': {
      id: 15,
      action: 'system',
      active: false,
      name: 'system',
      shortcut: 's ',
      order: 5,
    },
    d: {
      action: 'auto_fill',
      active: true,
      name: 'auto_fill',
      shortcut: 'd',
      order: 6,
    },
    'ctrl + m': {
      action: 'focusFirstBet',
      active: true,
      name: 'focus_first_bet',
      shortcut: 'ctrl + m',
      order: 7,
    },
    'ctrl + s': {
      action: 'editStakePerBet',
      active: true,
      name: 'edit_stake_per_bet',
      shortcut: 'ctrl + s',
      order: 8,
    },
    'ctrl + b': {
      action: 'focusFirstInput',
      active: true,
      name: 'focus_first_input',
      shortcut: 'ctrl + b',
      order: 9,
    },
    'ctrl + e': {
      action: 'toggleEditMode',
      active: false,
      name: 'toggle_delete_bet_mode',
      shortcut: 'ctrl + e',
      order: 10,
    },
    delete: {
      action: 'deleteBet',
      active: false,
      name: 'delete_bet',
      shortcut: 'delete',
      order: 11,
    },
    i: {
      id: 2,
      action: 'show',
      active: true,
      name: 'show',
      shortcut: 'i',
      order: 12,
    },
    t: {
      id: 3,
      action: 'place',
      active: true,
      name: 'place',
      shortcut: 't',
      order: 13,
    },
    w: {
      id: 4,
      action: 'sumFirstThree',
      active: true,
      name: 'sum_first_three',
      shortcut: 'w',
      order: 14,
    },
    e: {
      id: 5,
      action: 'sumFirstTwo',
      active: true,
      name: 'sum_first_two',
      shortcut: 'e',
      order: 15,
    },
    o: {
      id: 6,
      action: 'notWinner',
      active: true,
      name: 'not_winner',
      shortcut: 'o',
      order: 16,
    },
    g: {
      id: 7,
      action: 'notPlace',
      active: true,
      name: 'not_place',
      shortcut: 'g',
      order: 17,
    },
    h: {
      id: 8,
      action: 'notShow',
      active: true,
      name: 'not_show',
      shortcut: 'h',
      order: 18,
    },
    p: {
      id: 9,
      action: 'winnerEvenOdd',
      active: true,
      name: 'winner_even_odd',
      shortcut: 'p',
      order: 19,
    },
    r: {
      id: 10,
      action: 'winnerHighLow',
      active: true,
      name: 'winner_under_over',
      shortcut: 'r',
      order: 20,
    },
    f: {
      id: 11,
      action: 'forecast',
      active: true,
      name: 'forecast',
      shortcut: 'f',
      order: 21,
    },
    j: {
      id: 12,
      action: 'tricast',
      active: true,
      name: 'tricast',
      shortcut: 'j',
      order: 22,
    },
    s: {
      id: 13,
      action: 'reverseForecast',
      active: true,
      name: 'reverse_forecast',
      shortcut: 's',
      order: 23,
    },
    k: {
      id: 14,
      action: 'reverseTricast',
      active: true,
      name: 'reverse_tricast',
      shortcut: 'k',
      order: 24,
    },
    m: {
      action: 'quickBetslipMode',
      active: false,
      name: 'enable_quick_betslip_mode',
      shortcut: 'm',
      order: 22,
    },
  },
  availableTicketActions: [
    {
      status: 'accepted',
      action: ['check', 'copy'],
    },
    {
      status: 'canceled',
      action: [],
    },
    {
      status: 'paidout',
      action: [],
    },
    {
      status: 'pending',
      action: ['checkStatus'],
    },
    {
      status: 'unknown',
      action: ['checkStatus'],
    },
    {
      status: 'failed',
      action: ['checkStatus'],
    },
    {
      status: 'payedout',
      action: [],
    },
  ],
  actionTypes: {
    add: 'TicketPayIn',
    payout: 'TicketPayout',
    cancel: 'TicketCancel',
    copy: 'TicketCopy',
  },
  printLayoutType: {
    add: 'ticketGreyhoundRaces',
    payout: 'ticketGreyhoundRacesPayout',
    cancel: 'ticketCancel',
    results: 'resultsGreyhoundRaces',
  },
};
